import React from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';

import { Container } from 'components/shared/container/Container.styled';
import { translate } from 'shared/utils/translate';
import { useGlobalState } from 'hooks';
import {
  SectionComponent,
  SectionFlattenProps,
  SectionLink,
} from '../section/Section.props';
import * as Styled from './GetTheApp.styled';

const IMG_BASE =
  'https://www.omio.com/gcs-proxy/static_content_repo/web/mobile-ad/badges/';

const GetTheApp = ({
  components,
  theme,
  intl,
}: WrappedComponentProps & SectionFlattenProps) => {
  const { locale } = useGlobalState();
  const component = (components?.[0] || {}) as SectionComponent;
  const color = theme?.color || '';
  const link = (components?.[0]?.links || {}) as SectionLink;

  return (
    <Container>
      <Styled.FlexWrapper>
        <Styled.Title>
          {component.title && (
            <Styled.H2 color={color}>
              {translate({ intl, id: component.title })}
            </Styled.H2>
          )}
          {component.subtitle && (
            <Styled.H3 color={color}>
              {translate({ intl, id: component.subtitle })}
            </Styled.H3>
          )}
          {component.body && (
            <Styled.ParagraphRegular isMarkdown={false} color={color}>
              {translate({ intl, id: component.body })}
            </Styled.ParagraphRegular>
          )}
          {link && (
            <Styled.Link color={color} href={link.url}>
              {translate({ intl, id: link.title || '' })}
            </Styled.Link>
          )}
          <Styled.PromoButtons>
            {component.promoButtons?.map(button => (
              <Styled.PromoButton
                href={button.url}
                target="_blank"
                rel="noreferrer noopenerr"
                key={button.type}
              >
                <img
                  src={
                    button.type === 'google'
                      ? `${IMG_BASE}/android/android-badge-${locale}.svg`
                      : `${IMG_BASE}/ios/ios-badge-${locale}.svg`
                  }
                  alt={
                    button.type === 'google'
                      ? 'Download for Android'
                      : 'Download for iOS'
                  }
                  loading="lazy"
                />
              </Styled.PromoButton>
            ))}
          </Styled.PromoButtons>
        </Styled.Title>
        <Styled.PromoImage
          src={component?.imageUrl}
          alt="Phone image"
          loading="lazy"
        />
      </Styled.FlexWrapper>
    </Container>
  );
};

export default injectIntl(GetTheApp);
